import { useQuery } from '@tanstack/react-query'
import { fetchSurveyFormQuestions } from '../api/surveyFormQuestions'
import { queryKeys } from '../api/queryKeys'

export function useSurveyFormQuestions() {
  const questionsQuery = useQuery({
    queryKey: queryKeys.surveyForm.questions(),
    queryFn: fetchSurveyFormQuestions,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  })

  return {
    ...questionsQuery,
    data: questionsQuery.data ?? [],
  }
}
